import type { RouteScopePolicy } from './transitions';
/** Filters are route-specific; record IDs, portals and recovery targets never travel. */
export function routeScopePolicy(pathname: string): RouteScopePolicy {
  const filters: string[] = [];
  // 06-04 is a catalogue, not a path-bound operation record.
  if (/^\/operations\/data-flows\/?$/.test(pathname)) return { pathname, presentationFilters: ['screenId'], pathBound: false };
  if (/^\/search\/?$/.test(pathname)) filters.push('q', 'scope');
  if (/^\/home\/?$/.test(pathname)) filters.push('view', 'status', 'activityType', 'activityState', 'activityFrom', 'activityTo');
  if (/^\/(costs|monitor)\/?$/.test(pathname)) filters.push('period', 'from', 'to');
  if (/^\/usage-cost\/trajectory\/?$/.test(pathname)) filters.push('month', 'date');
  if (/^\/(releases|environments|operations)\/?$/.test(pathname)) filters.push('tab', 'view', 'status');
  if (/^\/(backups|backup-restore|recovery)(\/|$)/.test(pathname)) filters.push('recovery_view');
  if (pathname === '/operations/attention') filters.push('attentionStatus', 'attentionType');
  const match = pathname.match(/^\/(environments|portals|jobs|operations|recovery)\/.+/);
  return { pathname, presentationFilters: filters, pathBound: Boolean(match),
    ...(match ? { destinationPath: `/${match[1]}` } : {}) };
}
